<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@1,600&family=Quicksand:wght@500&family=Merriweather:wght@700&family=Manrope:wght@600&family=Lora:wght@600&display=swap" rel="stylesheet">

<div class="section" id="experience">
    <div class="container cc-education">
        <div class="card" data-aos="fade-up" data-aos-offset="10" >
              
        <div class="card-body" >
        <div class="h4 text-center mb-4 title">Tracie's Qualifications</div>
        <div class="colorlib-narrow-content">

            <div class="row">
                <div class="container" style="margin-left:5%;">🧡 LCSW Licensed Clinical Social Worker- NJ #44C05300700<br><a href="https://newjersey.mylicense.com/verification/Search.aspx?facility=N"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;https://newjersey.mylicense.com/verification/Search.aspx?facility=N</a><br><br>
                    🧡 MSW Rutgers State University<br><br>
                    🧡 MA Counselling Montclair State University<br><br>
                    🧡 BA double major Psychology and Sociology from Rutgers State University<br><br>
                    🧡 National Board Certified Fellow Clinical Hypnotherapist<br>
                    <a href="https://natboard.com"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;www.natboard.com</a><br><br>
                    🧡 Certified Hypnotherapist by North American Guild of Hypnotists<br>
                    <a href="https://ngh.net/"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;https://ngh.net/</a><br><br>
                    🧡 SIFI Supervisory Training by Rutgers State University<br>
                    <a href="http://socialwork.rutgers.edu/SearchResults.aspx?IndexCatalogue=Page+Index&amp;SearchQuery=Seminar+in+field+instruction"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;http://socialwork.rutgers.edu/SearchResults.aspx?IndexCatalogue=Page+Index&amp;SearchQuery=Seminar+in+field+instruction</a><br><br>
                    🧡 Certification of completion of 40 hours of Divorce Mediation training by NJ Association of Professional Mediators<br>
                    <a href="http://www.njapm.org/"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;http://www.njapm.org/</a><br><br>
                    🧡 Certified in Clinical Supervision by Family Intervention Services (NASW approved)<br>
                   <br>
                    🧡 Amen Clinic Affiliate Provider training Specializing in Neuro Science in Mental Health (in progress)<br>
                    <br>
                    🧡 Certificate of Comp Prof Training Prog: Family Track by Admin Office of the Courts, Superior Court Family Division<br><br>
                    🧡 Certified Criminologist by Rutgers State University<br>
                     <br><br>
                    </div>

                </div>
                </div>
            </div>
        </div>
    </div>
</div>